// Single source of truth for all display prices in the client.
// Server-side source of truth is in server/index.js (PLAN_PRICES, ADDON_PRICES, UNIT_PRICE_CENTS).

export const PARENT_PLAN_PRICES = {
  individual: { monthly: '$19.99', annualPerMonth: '$12.50', annual: '$149.99', annualBilled: '$149.99, billed annually' },
  family:     { monthly: '$39.99', annualPerMonth: '$25.00', annual: '$299.99', annualBilled: '$299.99, billed annually' },
};

export const INVITE_PRICES = {
  parent_pays:      { monthly: '$6.99', annualPerMonth: '$4.17', annual: '$49.99', annualBilled: '$49.99, billed annually' },
  club_parent_pays: { monthly: '$5.99', annualPerMonth: '$3.33', annual: '$39.99', annualBilled: '$39.99, billed annually' },
};

export const CLUB_PAYS_PRICES = {
  monthly: '$1.99', annualPerMonth: '$1.58', annual: '$19',
};
